/* eslint-disable import/no-cycle */
import { TFunction } from 'react-i18next';
import { LANGUAGE_CODE, SCREENING_TYPE } from './questionnaireTemplate.enums';
import { Language } from './questionnaireTemplate.types';

// istanbul ignore next
export const SCREENING_TYPE_LABELS: (t: TFunction<'questionnaireTemplate'>) => Record<SCREENING_TYPE, string> = (t) =>
  ({
    [SCREENING_TYPE.NONE]: t('formBuilder.canvas.element.screeningTypes.none'),
    [SCREENING_TYPE.KNOKOUT]: t('formBuilder.canvas.element.screeningTypes.knockout'),
    [SCREENING_TYPE.REVIEW]: t('formBuilder.canvas.element.screeningTypes.review'),
  } as const);

export const MAX_LENGTH_OPTIONS: number[] = [25, 50, 75, 100];

export const DEFAULT_MAX_LENGTH = 500;
export const VIDEO_RESPONSE_MAX_LENGTH = 300;

export const sharedLayoutTransition = {
  type: 'spring',
  stiffness: 500,
  damping: 40,
  mass: 1,
  precision: 0.01,
};

export const MAX_BRANCH_DEPTH = 4;

export const LANGUAGES: Language[] = [
  { code: LANGUAGE_CODE.EN, label: 'English' },
  { code: LANGUAGE_CODE.FR, label: 'French' },
];

export const DENORMALIZED_KEYS_TO_STRIP = [
  'expanded',
  'activeBranches',
  'config',
  'parentBranch',
  'parentId',
  'screeningType',
  'label',
] as const;

export const OPTIONS_TEXT_MAX_LENGTH = 120;
